/**
 * Google userinfo fetch — requires the access token to carry the
 * `https://www.googleapis.com/auth/userinfo.email` scope.
 */
const USERINFO_URL = 'https://www.googleapis.com/oauth2/v3/userinfo';
export async function fetchGoogleUserInfo(token) {
    try {
        const response = await fetch(USERINFO_URL, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok)
            return null;
        const data = (await response.json());
        if (!data.email)
            return null;
        return { email: data.email, name: data.name, picture: data.picture };
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=userinfo.js.map